import { defineStore } from "pinia";

// Единые «ворота» входа: действие, прерванное входом (сохранить маршрут,
// регистрация выхода, редактор), выполняется после успешного входа.
// Закрыли окно без входа - действие сбрасывается. LoginModal сначала
// шлёт "logged", потом "close" - поэтому App.vue забирает действие
// (takePending) по "logged", до close().
export const useLoginGateStore = defineStore("loginGate", {
  state: () => ({
    isOpen: false,
    pending: null as (() => void) | null,
  }),
  actions: {
    open(action?: () => void) {
      this.pending = action ?? null;
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
      this.pending = null;
    },
    takePending(): (() => void) | null {
      const action = this.pending;
      this.pending = null;
      return action;
    },
    // По "logged": забрать действие до close(), дождаться обновления состояния
    // (профиль, сохранённые маршруты) и только потом выполнить - иначе
    // действие увидит гостя или пустой список сохранённых.
    async complete(refresh: () => Promise<void>, isAuthed: () => boolean) {
      const action = this.takePending();
      await refresh();
      if (isAuthed()) action?.();
    },
    requireLogin(isAuthed: boolean, action: () => void) {
      if (isAuthed) action();
      else this.open(action);
    },
  },
});
